<section class="error-page">
    <div class="error-box">
        <div class="error-body text-center">
            <img alt="" src="assets/img/logo.png" class="m-5">
            <h3 class="text-uppercase">¡Página no encontrada!</h3>
            <p class="text-muted text-uppercase m-t-30 m-b-30">Utilice el siguiente enlace para regresar:</p>
            <button (click)="navigateBack()" class="btn btn-info btn-rounded m-b-40">Volver</button>
        </div>
    </div>
</section>
